export default "__VITE_PUBLIC_ASSET__c1f2e6bd__"